import { getDesignToken } from 'styles/constants';

export const incrementorDisplayValueStyleProps = () => ({
  background: 'transparent',
  height: '$8',
  minWidth: '$8',
  width: '$8',
});

export const incrementorButtonStyleProps = ({ disabled }: { disabled?: boolean }) => ({
  padding: '$0',
  borderRadius: 'full',
  borderWidth: '2',
  borderColor: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
  _icon: {
    size: 'xs',
    borderColor: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
    color: getDesignToken(disabled ? 'icon-disabled' : 'text-default'),
  },
});
